<p>{{ isExpanded ? text : truncatedText }}</p>
@if (text.length > limit) {
  <button class="mt-3 cursor-pointer" (click)="toggle($event)">
    <span class="inline-block text-grey-500">{{ isExpanded ? 'Read less' : 'Read more' }} <i class="pi text-sm ml-1" [class.pi-chevron-up]="isExpanded" [class.pi-chevron-down]="!isExpanded"></i></span>
  </button>
}
